import Vue from 'vue'

export default {
  setUsers: (state, value) => {
    state.users = value
  },
  removeUserById: (state, userId) => {
    const index = state.users.findIndex(user => user.Id === userId)
    state.users.splice(index, 1)
  },
  setUserRegions: (state, value) => {
    state.userRegions = value
  },
  setUserPlaces: (state, value) => {
    state.userPlaces = value
  },
  setUserZones: (state, value) => {
    state.userZones = value
  },
  /**
   * Set user/owner in users array
   * @param {Owner} user - user/owner Object
   */
  setUserInUsersArray: (state, payload) => {
    const userIndex = state.users.findIndex(user => user.Id === payload.Id)
    Object.assign(state.users[userIndex], payload)
  },
  /**
   * Sets specified key value on owner Object
   * @param {Object} object - { key: 'Name', value: 'Test Name Value' }
   */
  setUserValue: (state, data) => {
    const userIndex = state.users.findIndex(user => user.Id === data.userId)
    Vue.set(state.users[userIndex], data.key, data.value)
  },
  addUser: (state, item) => {
    const userIndex = state.users.findIndex(user => user.Id === item.Id)
    if (userIndex === -1) {
      state.users.push(item)
    }
  },
  setCurrentPageNumber: (state, value) => {
    state.currentPageNumber = value
  },
  setPageSize: (state, value) => {
    state.pageSize = value
  },
  setNextAvailablePage: (state, value) => {
    state.nextAvailablePage = value
  }
}
